import { render } from "./Estadistica.vue?vue&type=template&id=50f66742&scoped=true"
import script from "./Estadistica.vue?vue&type=script&lang=js"
export * from "./Estadistica.vue?vue&type=script&lang=js"

import "./Estadistica.vue?vue&type=style&index=0&id=50f66742&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f66742"]])

export default __exports__